module.exports = __webpack_public_path__ + "static/img/ninja-can-04.124929be.png";